import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'error';
export interface Toast {
  id: number;
  kind: ToastKind;
  text: string;
}

interface ToastState {
  toasts: Toast[];
  push: (text: string, kind?: ToastKind, ttlMs?: number) => number;
  dismiss: (id: number) => void;
}

let seq = 0;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push: (text, kind = 'info', ttlMs = kind === 'error' ? 8000 : 3500) => {
    const id = ++seq;
    set({ toasts: [...get().toasts.slice(-4), { id, kind, text }] });
    if (ttlMs > 0) setTimeout(() => get().dismiss(id), ttlMs);
    return id;
  },
  dismiss: (id) => set({ toasts: get().toasts.filter((x) => x.id !== id) }),
}));

export const toast = {
  info: (text: string) => useToasts.getState().push(text, 'info'),
  success: (text: string) => useToasts.getState().push(text, 'success'),
  error: (text: string) => useToasts.getState().push(text, 'error'),
};
